<template>
<div style="height:100%">
<div style="display:flex;height:100%">
    <div>
        <v-toolbar dark class="primary" condensed>
            <v-btn @click.native="$router.push('/home')" icon>
                <v-icon>chevron_left</v-icon>
            </v-btn>        
            <v-toolbar-title>Templates</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon>
                <v-icon>search</v-icon>
            </v-btn>
            <v-btn icon>
                <v-icon>more_vert</v-icon>
            </v-btn>
        </v-toolbar>  

        <v-container>
        <v-row wrap>
            <!-- ***************** Left Column ******************* -->
            <v-col xs12 sm4>
                left column...
            </v-col>

            <!-- ***************** Right Column ******************* -->
            <v-col xs12 sm8>
                <Section v-for="section in sections" :section="section" :key="section.key"/>
            </v-col> 
            <!-- End right column -->
        </v-row>
        </v-container>  
    </div>
    <div style="width:300px;height:100%;overflow-y:auto;" class="blue lighten-5">
        <v-toolbar dark class="primary" condensed>       
            <v-toolbar-title>Editor</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon>
                <v-icon>more_vert</v-icon>
            </v-btn>
        </v-toolbar>   
        <portal-target name="sidebar">

        </portal-target>     
    </div>
</div>


</div>
</template>

<script>
    import NumberHelpers from '../helpers/NumberHelpers'
    import Section from '../builder/Section'
    import EditPanel from '../builder/EditPanel'
    import DataHelpers from '../helpers/DataHelpers'
    import FirebaseHelpers from '../helpers/FirebaseHelpers'

    export default {
        name: 'ItemList',
        components: {
            Section,
            EditPanel,
        },
        data() {
            return {
                sections: []
            }
        },
        computed:{
            page() {
                return this.$route.params.page
            },

        },
        methods: {

        },

        created() {
            let ref = DataHelpers.getTenantRef().child('sections').orderByChild('page').equalTo(this.page)
            ref.once('value', (snap) => {
                this.sections = FirebaseHelpers.snapshotToArray(snap)
            })
        }

    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// ItemList.vue?48cd5d8f